import {mapGetters, mapState} from 'vuex'

const deviceTypeEnum = {ANDROID: 'ANDROID', IOS: 'IOS'}

const configPerDeviceType = {
  [deviceTypeEnum.ANDROID]: {
    isCurrentDevice: () => /android/i.test(navigator.userAgent || navigator.vendor || window.opera),
    getUrl: ({phoneNumber, message}) => `sms:${phoneNumber}?body=${message}`
  },
  [deviceTypeEnum.IOS]: {
    isCurrentDevice: () => /iPad|iPhone|iPod/.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream,
    getUrl: ({phoneNumber, message}) => `sms:${phoneNumber}&body=${message}`
  }
}

const getDeviceType = () => {
  const foundDevice = Object.entries(configPerDeviceType).find(([_deviceType, {isCurrentDevice}]) => isCurrentDevice())

  return foundDevice ? foundDevice[0] : null
}

export const subscriptionOperationEnum = {REGISTER: 'REGISTER', RESUBSCRIBE: 'RESUBSCRIBE'}

export const subscriptionTypeEnum = {DAILY: 'DAILY', ONE_TIME: 'ONE_TIME'}

const subscribeTextMapPerSubscriptionType = {
  [subscriptionTypeEnum.DAILY]: {
    mobilePhoneNumberKey: () => 'mobile_phone_number_for_daily_subscription',
    mobileMessageKey: () => 'mobile_message_for_daily_subscription',
    modalTextKey: operation => ({
      [subscriptionOperationEnum.REGISTER]: 'home_modals_simplify_registration_text_for_daily_subscription',
      [subscriptionOperationEnum.RESUBSCRIBE]: 'home_modals_resubscribe_text_for_daily_subscription'
    }[operation]) || ''
  },
  [subscriptionTypeEnum.ONE_TIME]: {
    mobilePhoneNumberKey: () => 'mobile_phone_number_for_one_time_subscription',
    mobileMessageKey: () => 'mobile_message_for_one_time_subscription',
    modalTextKey: operation => ({
      [subscriptionOperationEnum.REGISTER]: 'home_modals_simplify_registration_text_for_one_time_subscription',
      [subscriptionOperationEnum.RESUBSCRIBE]: 'home_modals_resubscribe_text_for_one_time_subscription'
    }[operation]) || ''
  }
}

const subscriptionMixin = {
  data () {
    return {
      subscriptionMixinDeviceType: getDeviceType()
    }
  },
  computed: {
    ...mapGetters('i18n', {
      subscriptionMixinGetTranslationByOperator: 'getTranslationByOperator'
    }),
    ...mapState('common', {
      subscriptionMixinMultiOperatorInfo: 'multiOperatorInfo'
    })
  },
  methods: {
    subscriptionMixinLaunchAction (
      subscriptionOperation,
      subscriptionType,
      launchModalModeCallback
    ) {
      if (!Object.values(subscriptionOperationEnum).includes(subscriptionOperation)) { return }

      const textKeyMap = subscribeTextMapPerSubscriptionType[subscriptionType]

      switch (this.subscriptionMixinDeviceType) {
        case deviceTypeEnum.ANDROID:
        case deviceTypeEnum.IOS:
          window.location.href = configPerDeviceType[this.subscriptionMixinDeviceType].getUrl({
            phoneNumber: this.subscriptionMixinGetTranslationByOperator(this.subscriptionMixinMultiOperatorInfo.multiOperatorOrdinal, textKeyMap.mobilePhoneNumberKey()),
            message: this.subscriptionMixinGetTranslationByOperator(this.subscriptionMixinMultiOperatorInfo.multiOperatorOrdinal, textKeyMap.mobileMessageKey())
          })
          break
        default:
          if (launchModalModeCallback) {
            launchModalModeCallback(textKeyMap.modalTextKey(subscriptionOperation))
          }
          break
      }
    }
  }
}

export default subscriptionMixin



// WEBPACK FOOTER //
// ./src/common/mixins/subscription.js